export default "__VITE_ASSET__C9FSZ9i3__"